import { Link } from "react-router-dom";
import Button from "../../components/Common/Button";
import usePagination from "../../components/Common/PaginationHooks";
import useSort from "../../components/Common/SortingHooks";
import Table from "../../components/Common/Table";
import TableHeader from "../../components/Common/TableHeader";
import { IzobrazevanjeListType } from "../../types/Izobrazevanje/IzobrazevanjeListType";
import { IzobrazevanjeStatus } from "../../utils/Enums";

type IzobrazevanjeJavnoListTableArgs = {
    izobrazevanjeData: IzobrazevanjeListType[];
}

const IzobrazevanjeJavnoListTable = ({ izobrazevanjeData }: IzobrazevanjeJavnoListTableArgs) => {

    const { setSort, sortedData, sortColumn, sortIcon } = useSort<IzobrazevanjeListType>(izobrazevanjeData);
    const { pageCount, paginate, setPaginate, currData, onPageChange } = usePagination<IzobrazevanjeListType>(sortedData);
    const TableHeaderProps = { sortColumn: sortColumn, onClickHandler: setSort, sortIcon: sortIcon };

    if (izobrazevanjeData.length <= 0) {
        return (
            <>
                <div>Ni podatkov za prikaz</div>
                <Link to="/izobrazevanje/javno-add">
                    <Button startIcon="add">
                        dodaj
                    </Button>
                </Link>
            </>
        );
    }

    return (
        <>
            <div>
                <Table
                    fullWidth
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    paginate={paginate}
                    setPaginate={setPaginate}
                >
                    <thead>
                        <tr>
                            <TableHeader {...TableHeaderProps}
                                indexName="naziv"
                                left>
                                Naziv
                            </TableHeader>
                            <TableHeader {...TableHeaderProps}
                                indexName="izobrazevanjeTipNaziv"
                                center>
                                Kategorija
                            </TableHeader>
                            <TableHeader {...TableHeaderProps}
                                width="12%"
                                center
                                indexName="statusNaziv">
                                Status
                            </TableHeader>
                        </tr>
                    </thead>
                    <tbody>
                        {currData && currData.map((izobrazevanje) => (
                            <tr key={izobrazevanje.izobrazevanjeId}>
                                <td className="txtLeft">
                                    <Link to={izobrazevanje.status == IzobrazevanjeStatus.Objavljeno ? `/izobrazevanje/${izobrazevanje.izobrazevanjeId}` : `/izobrazevanje/edit/${izobrazevanje.izobrazevanjeId}`}>
                                        {izobrazevanje.naziv}
                                    </Link>
                                </td>
                                <td className="txtCenter">{izobrazevanje.izobrazevanjeTipNaziv}</td>
                                <td className="txtCenter">{izobrazevanje.statusNaziv}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Link to="/izobrazevanje/javno-add">
                <Button startIcon="add">
                    dodaj
                </Button>
            </Link>
        </>
    );
}

export default IzobrazevanjeJavnoListTable;